module.exports = __webpack_public_path__ + "img/pauli-z-root-dagger-25.0ff84cca.svg";